import React from "react";

const TIERS = [
  {
    label: "Base fee",
    oldPrice: "$300",
    newPrice: "$250",
    desc: "Invite as many guests as you'd like — one fixed price.",
  },
  {
    label: "Custom design",
    oldPrice: "+$100",
    newPrice: "+$50",
    desc: "Send us your favorite invite — we'll bring it to life.",
    hint: "+ 5–7 business days",
  },
  {
    label: "Custom song",
    oldPrice: "+$30",
    newPrice: "Free",
    free: true,
    desc: "Upload your favorite song and we'll set it as the soundtrack.",
    hint: "+ 1–2 business days",
  },
  {
    label: "Allow RSVP",
    newPrice: "+$50",
    desc: "Let your invitees RSVP directly from the invitation.",
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="pc-section papercraft">
      <header className="pc-section__head">
        <span className="pc-eyebrow">Simple, honest pricing</span>
        <h2 className="pc-section__title">
          Invitation <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>pricing</em>.
        </h2>
        <p className="pc-section__lede">
          One fee covers your whole guest list. Add what you need, leave what you don't.
        </p>
      </header>

      <div className="pc-prices">
        {TIERS.map((t) => (
          <div key={t.label} className="pc-price">
            <span className="pc-price__label">{t.label}</span>
            <div className="pc-price__amount">
              {t.oldPrice && <span className="pc-price__amount-old">{t.oldPrice}</span>}
              <span className={t.free ? "pc-price__free" : "pc-price__amount-new"}>
                {t.newPrice}
              </span>
            </div>
            <p className="pc-price__desc">{t.desc}</p>
            {t.hint && <div className="pc-price__hint">{t.hint}</div>}
          </div>
        ))}
      </div>

      <aside className="pc-price pc-price--feature">
        <span className="pc-price__label">The combo deal</span>
        <h3 className="pc-price__title">
          Getting married? Go green on every invitation.
        </h3>
        <div className="pc-price__amount">
          <span className="pc-price__amount-old">$1,200</span>
          <span className="pc-price__amount-old">$600</span>
          <span className="pc-price__amount-new">$500</span>
        </div>
        <p className="pc-price__desc">
          Save the Date, engagement, bridal shower, and wedding invitations —
          all for the price of two.
        </p>
      </aside>
    </section>
  );
}
